<template>
  <div class="project">
    <div>
      <span class="project-title">名称：&nbsp;&nbsp;</span>
      <span>{{ item.name }}</span>
    </div>
    <br />
    <a-table
      :columns="columns"
      :data-source="tableData"
      rowKey="id"
      size="small"
      class="project-table"
      :pagination="false"
    >
      <template slot="index" slot-scope="text, record, index">
        {{ index + 1 }}
      </template>
      <template slot="operation" slot-scope="text, record">
        <a-popconfirm
          title="确认要修改么？"
          ok-text="是"
          cancel-text="否"
          @confirm="handleOperationStatus(record)"
          @cancel="
            () => {
              $message.warning('取消修改');
            }
          "
        >
          <a-tag :color="record.is_enable ? 'blue' : 'red'">{{
            record.is_enable ? "运维" : "恢复"
          }}</a-tag>
        </a-popconfirm>
      </template>
    </a-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { flattenTree } from "@/utils/utils";
import {
  getStationListByGroupId,
  updateStationOperationStatus
} from "@/api/api";
import { device_edit_project_columns } from "@/options/columns";
export default {
  data() {
    return {
      item: [],
      flattenGroupTree: [],
      tableData: [],
      columns: device_edit_project_columns
    };
  },
  computed: {
    ...mapState(["groupTree"])
  },
  watch: {
    $route() {
      this.getItem();
    }
  },
  mounted() {
    this.flattenGroupTree = flattenTree(this.groupTree);
    this.getItem();
  },
  methods: {
    async getItem() {
      this.item =
        this.flattenGroupTree.find(x => x.id == this.$route.params.id) || {};
      try {
        let res = await getStationListByGroupId(this.item.id);
        this.tableData = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async handleOperationStatus(item) {
      let oprt = item.is_enable;
      await updateStationOperationStatus(item.id, oprt);
      await this.getItem();
    }
  }
};
</script>

<style lang="less" scoped>
.project {
  padding: 10px;
  font-size: 18px;
  color: #606266;
}
.project-title {
  font-weight: bold;
}
.project-table /deep/ .ant-table-thead {
  background-color: #f8f8f8;
}
.project-table /deep/ .ant-table-tbody > tr:nth-child(even) {
  background-color: #f8f8f8;
}
</style>
